import { yup } from '@framework/validation';
import { CommonBaseWidgetSchema } from '../../../CommonBaseWidgetSchema';
import { IGraphicWidget } from '../IGraphicWidget';

export const CommonGraphicWidgetConfigSchema: yup.ObjectSchema<IGraphicWidget> =
  CommonBaseWidgetSchema.shape({
    enabled: yup.mixed().notRequired().strip(),
  })
    .required()
    .noUnknown();
